import { apiFetch } from "@/lib/api";

export async function generatePurchaseOrderPdf(purchaseOrderId: number): Promise<string> {
  const data = await apiFetch<{ pdfBase64: string }>(
    `/api/mrp/purchase-orders/${String(purchaseOrderId)}/pdf`,
    { method: "POST", body: {} },
  );
  return data.pdfBase64;
}

export function downloadPurchaseOrderPdf(
  base64: string,
  purchaseOrderNumber: string | null,
  purchaseOrderId: number,
): void {
  const label = purchaseOrderNumber?.trim() || `purchase-order-${String(purchaseOrderId)}`;
  const link = document.createElement("a");
  link.href = `data:application/pdf;base64,${base64}`;
  link.download = `${label}.pdf`;
  link.click();
}
